import { useCallback, useEffect } from "react";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	FormHeaderComponent,
} from "../../components/styled/common";
import BackComponent from "../../components/BackComponent";
import MainButtonComponent from "../../components/MainButtonComponent";
import KvkkForm, { applyKvkkLocalizableChanges, KvkkLocalizableChanges } from "../../components/KvkkForm";
import { useKvkkContext } from "../../context/KvkkContext/KvkkContext";
import { KVKK_LIST_PATH, KvkkGeneralFormData } from "../../context/KvkkContext/constants";
import { Culture } from "../../context/VolunteersHighlightContext/constants";

const AddKvkk = () => {
	const { addKvkk, clearKvkkFormData, kvkkForm, setKvkkForm, operationStatus } = useKvkkContext();

	useEffect(() => {
		clearKvkkFormData();

		return () => {
			clearKvkkFormData();
		};
	}, [clearKvkkFormData]);

	const handleGeneralChange = useCallback((changes: Partial<KvkkGeneralFormData>) => {
		setKvkkForm(prev => ({ ...prev, ...changes }));
	}, [setKvkkForm]);

	const handleLocalizableChange = useCallback((culture: Culture, changes: KvkkLocalizableChanges) => {
		setKvkkForm(prev => ({
			...prev,
			kvkkTextLocalizable: applyKvkkLocalizableChanges(prev.kvkkTextLocalizable, culture, changes),
		}));
	}, [setKvkkForm]);

	return (
		<>
			<BackComponent text="KVKK Metinleri Listesine Dön" to={KVKK_LIST_PATH} />
			<ActionContainer>
				<ActionItemsContainer>
					<FormHeaderComponent>KVKK Metni Ekleme</FormHeaderComponent>
					<KvkkForm
						general={kvkkForm}
						localizables={kvkkForm.kvkkTextLocalizable}
						isRequired
						onGeneralChange={handleGeneralChange}
						onLocalizableChange={handleLocalizableChange}
					/>
					<SubmitButtonOverlay>
						<MainButtonComponent
							onClick={addKvkk}
							loading={operationStatus.type === "loading" && operationStatus.operation === "add"}
						>
							KVKK Metni Ekle
						</MainButtonComponent>
					</SubmitButtonOverlay>
				</ActionItemsContainer>
			</ActionContainer>
		</>
	);
};

export default AddKvkk;
